export default "__VITE_PUBLIC_ASSET__716adb92__"